/**
 * Shared Utilities - Moon Moon Agency
 * Essential utilities and helpers shared across all modules
 */

/*********************************************************************************************
 * 🌐 GLOBAL SETTINGS
 */
// Development mode detection
window.isDev = typeof isDevelopment !== 'undefined' ? isDevelopment : false;

// Mobile breakpoint (most commonly used)
window.MOBILE_BREAKPOINT = 768;

/*********************************************************************************************
 * 🛠️ SHARED UTILITIES
 */
// Simple logging utility
window.log = (level, module, message, data = {}) => {
	if (!window.isDev && level === 'info') return;
	if (typeof console !== 'undefined') {
		const logFn = console[level] || console.log;
		const timestamp = window.getTimestamp?.() || new Date().toLocaleString();
		logFn(`${module} ${message}`, { timestamp, ...data });
	}
};

// Simple event emitter
window.emit = (event, detail = {}) => {
	return document.dispatchEvent(new CustomEvent(event, {
		detail: { timestamp: window.getTimestamp?.() || new Date().toLocaleString(), ...detail },
		bubbles: true
	}));
};

// DOM utilities
window.getElement = (selector) => document.querySelector(selector);
window.getElements = (selector) => document.querySelectorAll(selector);

// Common utilities
/**
 * Global isMobile detection (breakpoint: 768px)
 *
 * NOTE: Multiple isMobile implementations exist in the codebase with different breakpoints:
 * - window.isMobile() → 768px (GLOBAL - Use this for consistency)
 * - DeviceManager.isMobile → 768px (mm_animation.js - Animation-specific)
 * - MobileFilters.isMobile() → 900px (mm_template_collection.js - Collection filters specific)
 *
 * The collection filters use 900px intentionally for tablet/desktop filter layout differences.
 * For general mobile detection, prefer using this global window.isMobile().
 */
window.isMobile = () => window.innerWidth <= window.MOBILE_BREAKPOINT;
window.debounce = (fn, delay) => {
	let timeout;
	return (...args) => {
		clearTimeout(timeout);
		timeout = setTimeout(() => fn.apply(this, args), delay);
	};
};

/*********************************************************************************************
 * 🕐 TIMESTAMP UTILITIES
 */
// French timestamp formatter
window.getTimestamp = () => new Date().toLocaleString('fr-FR', {
	year: 'numeric',
	month: '2-digit',
	day: '2-digit',
	hour: '2-digit',
	minute: '2-digit',
	second: '2-digit'
});

/*********************************************************************************************
 * 🎯 ACCESSIBILITY - Share URL Select on Click (replace inline onclick)
 */
document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('[data-share-url]').forEach((input) => {
		input.addEventListener('click', () => {
			input.select();
		});
	});
});

/*********************************************************************************************
 * 🔧 DEVELOPMENT LOGGING
 */
if (window.isDev) {
	const eventConfig = {
		// Navigation & Filter events
		'mobile-menu-toggled': '📱',

		// Search events
		'search-opened': '🔍',
		'search-closed': '🔍',

		// UI Components events
		'dropdown-toggled': '📖',
		'read-more-toggled': '📝',

		// Media events
		'video-manager-initialized': '🎥',

		// Recommendations events
		'product-recommendations-loaded': '🛍️'
	};

	Object.entries(eventConfig).forEach(([event, emoji]) => {
		document.addEventListener(`global:${event}`, e =>
			console.log(`${emoji} [${event.toUpperCase()}]:`, e.detail)
		);
	});
}

/*********************************************************************************************
 * Focus
 */
document.addEventListener('focusin', e => {
	console.log('FOCUS ON:', e.target);
});